import styled from "styled-components";
import { theme } from "../../theme/GlobalTheme";

export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.sm} ${theme.spacing.xl};
  background-color: rgba(0, 33, 105, 0.04);
  border-bottom: 1px solid rgba(0, 33, 105, 0.08);
  font-family: ${theme.typography.fontFamily};
`;

export const Nav = styled.nav`
  display: flex;
  gap: ${theme.spacing.lg};
`;

export const Title = styled.span`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.textPrimary};
  font-weight: ${theme.typography.fontWeight.normal};
  font-family: ${theme.typography.fontFamily};
`;

export const UserLabel = styled.span`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.textPrimary};
  font-weight: ${theme.typography.fontWeight.bold};
  font-family: ${theme.typography.fontFamily};
`;

export const ProjectInfo = styled.span`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.textPrimary};
  font-weight: ${theme.typography.fontWeight.normal};
  font-family: ${theme.typography.fontFamily};
`;

export const ProjectLink = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;
  font-weight: ${theme.typography.fontWeight.bold};
  transition: color 0.2s ease-in-out;

  &:visited {
    color: ${theme.colors.primary};
  }

  &:hover {
    color: ${theme.colors.secondary};
    text-decoration: underline;
  }
`;

